import { Calendar, Clickable, Col, Text } from 'components';
import { useOutsideClick } from 'core';
import { formatLocale } from 'lib';
import { useRef, useState } from 'react';
import styled from 'styled-components';

const CalendarContainer = styled.div`
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 30px;
  left: 0;
  z-index: 10;
`;

const DatePicker = ({
  selected,
  handleSelect,
  title,
  minDate,
  maxDate,
  marg,
  disabled,
  timeIntervals
}) => {
  const [visible, setVisible] = useState(false),
    componentRef = useRef();

  useOutsideClick(componentRef, handleVisible, [
    'admin-date-picker',
    'admin-date-picker-text',
    'react-datepicker__current-month',
    'react-datepicker__navigation--next--with-time'
  ]);

  function handleVisible() {
    setVisible(!visible);
  }

  return (
    <Col noFlex pos="relative" wid="450px" className="admin-date-picker" marg={marg}>
      {title && (
        <Text b2 med marg="0 16px 4px">
          {title}
        </Text>
      )}

      <Clickable
        onClick={handleVisible}
        className="admin-date-picker-text"
        disabled={disabled}
        ogOpacity
      >
        <Text className="admin-date-picker-text">
          {selected ? formatLocale(selected, 'LLL do y, KK:mm a') : 'Click here to select'}
        </Text>
      </Clickable>

      {visible && (
        <CalendarContainer ref={componentRef}>
          <Calendar
            timeIntervals={timeIntervals || 10}
            selected={selected}
            onChange={handleSelect}
            showTimeSelect
            inline
            minDate={minDate}
            maxDate={maxDate}
          />
        </CalendarContainer>
      )}
    </Col>
  );
};

export default DatePicker;
